export default __webpack_public_path__ + "static/media/avatar_nikki_dog1.8628c951.mp3";